import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { ConsoleCard } from '../../ConsoleFragments';
import TroubleshootingInstructionsContent
    from '../TroubleshootingInstructionsContent/TroubleshootingInstructionsContent';
import BrowserStore from '../../../browser/stores/BrowserStore';
import FuseBrowserModal from '../../BrowserModal/FuseBrowserModal';
import { isFuse5Enabled } from '../../../fuseFeatureFlag';
import OldTroubleshootingInstructionsModal from './OldTroubleshootingInstructionsModal';

class NewTroubleshootingInstructionsModal extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        browser: BrowserStore.PropType.isRequired,
    };

    render() {
        const { t, browser } = this.props;

        return <FuseBrowserModal
            isOpen={browser.troubleshootingInstructionsModal.isOpen}
            onClose={browser.troubleshootingInstructionsModal.close}
            title={t('troubleshootingMode.instructions.modalTitle')}
            hideBackButton
            hideFooter
        >
            <TroubleshootingInstructionsContent
                t={t}
                renderAsCards
                CardComponent={ConsoleCard}
            />
        </FuseBrowserModal>;
    }
}

const WrappedNewTroubleshootingInstructionsModal = translate()(
    inject('browser')(observer(NewTroubleshootingInstructionsModal))
);

const TroubleshootingInstructionsModal = () => {
    return isFuse5Enabled() ? <WrappedNewTroubleshootingInstructionsModal /> : <OldTroubleshootingInstructionsModal />;
};

export default TroubleshootingInstructionsModal;
